import { FC } from 'react';
import { useIntl } from 'react-intl';

import {
  hasNoSpeechDetected,
  TranscriptorConsultation,
} from '@/entities/transcriptor';

import { dentalConsultationMessages } from '../../config';
import { ConsultationNotice } from '../ConsultationNotice';

type NoSpeechNoticeProps = {
  consultation?: TranscriptorConsultation | null;
  className?: string;
};

/**
 * Exactly one notice per recording: "no speech" is a single shared skipped
 * state, so the message renders once at the top of the page, not per document.
 */
export const NoSpeechNotice: FC<NoSpeechNoticeProps> = ({
  consultation,
  className,
}) => {
  const { formatMessage } = useIntl();

  if (!hasNoSpeechDetected(consultation)) {
    return null;
  }

  return (
    <ConsultationNotice
      className={className}
      title={formatMessage(dentalConsultationMessages.noSpeechDetectedLabel)}
      message={formatMessage(
        dentalConsultationMessages.noSpeechDetectedMessage,
      )}
    />
  );
};
